<template>

    <div dusk="calendar"
        :class="{
            'overflow-x-auto': true,
            'cursor-move': dragging.row
        }"
    >

        <div dusk="pulledMaterialWarnings" class="mb-4">
            <!-- Keuringsdatum bijna verlopen-->
            <div
                v-if="this.pulledMaterialWarningGroups.next_examination_needed_soon.length"
                class="rounded-md bg-yellow-50 p-4"
            >
                <div class="flex">
                    <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="flex flex-col ml-3">
                        <span class="text-sm font-medium">
                            <span class="text-yellow-800">Keuringsdatum ligt binnen 1 maand!</span>
                            <button class="text-yellow-900 font-bold" @click="toggleWarning('examination-warning')"> Klik hier voor details. </button>
                        </span>
                        <div
                            v-if="this.toggledWarnings['examination-warning']"
                            class="mt-2 text-sm text-orange-700"
                        >
                            <ul role="list" class="list-disc space-y-1 pl-5">
                                <li v-for="warning in this.pulledMaterialWarningGroups.next_examination_needed_soon">
                                    <span class="font-bold">{{ warning.license_plate }}</span>
                                    <span> - </span>
                                    <span>{{ new Date(warning.next_examination_date).toLocaleDateString() }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Vergunningsdatum bijna verlopen-->
            <div
                v-if="this.pulledMaterialWarningGroups.permits_expiring_soon.length"
                class="rounded-md bg-yellow-50 p-4 mt-4"
            >
                <div class="flex">
                    <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="flex flex-col ml-3">
                        <span class="text-sm font-medium">
                            <span class="text-yellow-800">Vergunningen vervallen binnenkort!</span>
                            <button class="text-yellow-900 font-bold" @click="toggleWarning('permits-warning')"> Klik hier voor details. </button>
                        </span>
                        <div
                            v-if="this.toggledWarnings['permits-warning']"
                            class="mt-2 text-sm text-orange-700"
                        >
                            <ul role="list" class="list-disc space-y-1 pl-5">
                                <li v-for="warning in this.pulledMaterialWarningGroups.permits_expiring_soon">
                                    <span class="font-bold">{{ warning.license_plate }}</span>
                                    <ul>
                                        <li v-for="permit in warning.permits">
                                            {{permit.name}} - {{permit.number}} - {{ new Date(permit.valid_until).toLocaleDateString() }}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="this.pulledMaterialWarningGroups.examination_expired.length"
                class="rounded-md bg-red-50 p-4 mt-4"
            >
                <div class="flex">
                    <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="flex flex-col ml-3">
                        <span class="text-sm font-medium">
                            <span class="text-yellow-800">Keuringsdatum(s) zijn verlopen!</span>
                            <button class="text-yellow-900 font-bold" @click="toggleWarning('examination-alert')"> Klik hier voor details. </button>
                        </span>
                        <div
                            v-if="this.toggledWarnings['examination-alert']"
                            class="mt-2 text-sm text-orange-700"
                        >
                            <ul role="list" class="list-disc space-y-1 pl-5">
                                <li v-for="warning in this.pulledMaterialWarningGroups.examination_expired">
                                    <span class="font-bold">{{ warning.license_plate }}</span>
                                    <span> - </span>
                                    <span>{{ new Date(warning.next_examination_date).toLocaleDateString() }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Vergunningsdatums verlopen-->
            <div
                v-if="this.pulledMaterialWarningGroups.permits_expired.length"
                class="rounded-md bg-red-50 p-4 mt-4"
            >
                <div class="flex">
                    <div class="flex-shrink-0">
                        <svg class="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="flex flex-col ml-3">
                        <span class="text-sm font-medium">
                            <span class="text-yellow-800">Vergunningsdatum(s) zijn verlopen!</span>
                            <button class="text-yellow-900 font-bold" @click="toggleWarning('permits-alert')"> Klik hier voor details. </button>
                        </span>
                        <div
                            v-if="this.toggledWarnings['permits-alert']"
                            class="mt-2 text-sm text-red-700"
                        >
                            <ul role="list" class="list-disc space-y-1 pl-5">
                                <li v-for="warning in this.pulledMaterialWarningGroups.permits_expired">
                                    <span class="font-bold">{{ warning.license_plate }}</span>
                                    <ul>
                                        <li v-for="permit in warning.permits">
                                            {{permit.name}} - {{permit.number}} - {{ new Date(permit.valid_until).toLocaleDateString() }}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-white overflow-hidden rounded-xl border divide-y min-w-[1000px]"
             @mousemove="isResizing($event)"
             @mouseup="stopResize()"
             @drop="onDrop"
             @dragover.prevent
             @dragenter.prevent
        >
            <div class="bg-gray-50 col-span-2 grid grid-cols-[10rem,_1fr]"
                 dusk="head"
            >
                <div></div>

                <div class="grid w-full" :class="gridColumnClass()" dusk="items">
                    <div class="col-span-4 pt-2"
                         v-for="time in numbersBetween(6, 19, 1)"
                    >
                        <div class="flex flex-col">
                            <span dusk="time">{{ time }}:00</span>
                            <div class="grid grid-cols-4">
                                <div class="h-2 border-l"></div>
                                <div class="h-2 border-l"></div>
                                <div class="h-2 border-l"></div>
                                <div class="h-2 border-l"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div dusk="body" class="relative z-10">

                <div class="absolute inset-0 layout -z-10">

                    <div class="grid grid-cols-[10rem,_1fr] h-full">
                        <div></div>
                        <div class="grid" :class="gridColumnClass()">
                            <div class="col-span-4 border-l pointer-events-none"
                                 v-for="time in numbersBetween(6, 19, 1)"
                            ></div>
                        </div>
                    </div>

                </div>

                <div class="rows">

                    <div class="grid grid-cols-[10rem,_1fr]"
                         v-for="(licensePlate, index) in this.propLicensePlates"
                         :dusk="'row-' + (index + 1)"
                    >

                        <div class="flex items-center px-4 py-2 text-sm"
                             :class="{
                                'border-b': index !== propLicensePlates.length - 1
                            }"
                        >
                            <div class="relative mr-auto" dusk="name">
                                <span
                                    :class="{
                                        'text-orange-400': licensePlate.permit_status.almost_passed.length,
                                        'text-red-400': licensePlate.permit_status.invalid.length,
                                        'cursor-pointer': (licensePlate.permit_status.invalid.length
                                            || licensePlate.permit_status.almost_passed.length
                                        )
                                    }"
                                    v-on:click="toggleLicensePlate(licensePlate)"
                                >{{ licensePlate.name }}</span>

                                <div class="absolute bg-white max-w-screen w-[400px] mt-2 p-4 rounded-lg shadow-md z-10 transition left-20 space-y-2"
                                    v-if="licensePlate.permit_status.invalid.length
                                        || licensePlate.permit_status.almost_passed.length
                                    "
                                    :class="{
                                        '-top-[calc(100%_+_170px)]': index + 1 > propLicensePlates.length - 4,
                                        'top-[calc(100%_-_30px)]': index + 1 <= propLicensePlates.length - 4,

                                        'opacity-100 pointer-events-auto': licensePlate.showPermits,
                                        'opacity-0 pointer-events-none': !licensePlate.showPermits,
                                    }"
                                >
                                    <div v-if="licensePlate.permit_status.invalid.length">
                                        <span>De volgende vergunningen zijn verlopen:</span>
                                        <div class="grid gap-2 mt-2">
                                            <div class="flex gap-4 px-4 py-2 text-red-400 bg-red-100 rounded-md" v-for="permit in licensePlate.permit_status.invalid">
                                                <div>{{ permit.name }}</div>
                                                <div>{{ permit.number }}</div>
                                                <div class="whitespace-nowrap">{{ permit.valid_until }}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="licensePlate.permit_status.almost_passed.length">
                                        <span>De volgende vergunningen verlopen binnenkort:</span>
                                        <div class="grid gap-2 mt-2">
                                            <div class="flex gap-4 px-4 py-2 text-orange-400 bg-orange-100 rounded-md" v-for="permit in licensePlate.permit_status.almost_passed">
                                                <div>{{ permit.name }}</div>
                                                <div>{{ permit.number }}</div>
                                                <div class="whitespace-nowrap">{{ permit.valid_until }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-shrink-0 w-8 h-8 ml-2 rounded-lg"
                                 :class="'bg-' + licensePlate.color + '-100' + ' text-' + licensePlate.color + '-800'"
                            ></div>
                        </div>

                        <div class="grid w-full"
                             ref="column"
                             :class="gridColumnClass()"
                             @dragover="onDragOver($event, index + 1)"
                        >
                            <div class="z-20 bg-white border-2 border-dashed opacity-50 pointer-events-none placeholder"
                                 v-if="dragging.row === ( index + 1 )"
                                 :style="{
                                    'grid-column': dragging.columnStart + ' / span ' + dragging.length,
                                    'grid-row': '1 / ' + getMaxSubRow(index + 1)
                                 }"
                            ></div>

                            <!-- TODO: If overflow, then start on on new row -->
                            <template v-for="item in getItemsByRow(index + 1)">

                                <div class="bg-white border-2 border-dashed opacity-50"
                                     v-if="item.box.length || item.box.columnStart"
                                     :class="{
                                        'z-10': item.box.length,
                                     }"
                                     :style="{
                                        'grid-column': (item.box.columnStart || item.columnStart) + ' / span ' + (item.box.length || item.length),
                                        'grid-row': getGridRow(item, getItemsByRow(index + 1))
                                     }"
                                ></div>

                                <a class="relative flex group"
                                   :dusk="item.id"
                                   :href="item.url"
                                   :data-label="item.label || ''"
                                   :class="{
                                        'pointer-events-none': dragging.resize,
                                        ['bg-' + licensePlate.color + '-100' + ' border border-' + licensePlate.color + '-200 text-' + licensePlate.color + '-800'] : true,
                                        'opacity-50 loading': item.loading,
                                     }"
                                   :style="{
                                        'grid-column': item.columnStart + ' / span ' + item.length,
                                        'grid-row': getGridRow(item, getItemsByRow(index + 1))
                                     }"
                                >

                                    <div class="flex w-full h-full"
                                         :class="{
                                            'pointer-events-none': calendarItemLongerThenDay(item)
                                         }"
                                    >
                                        <div
                                            class="absolute top-0 z-10 flex justify-between px-2 py-1 -mt-2 text-xs text-black transform -translate-x-1/2 -translate-y-full bg-white border rounded opacity-0 pointer-events-none group-hover:opacity-100 left-1/2 whitespace-nowrap"
                                        >
                                            <span v-if="item.label">{{ item.label }}</span>
                                            <span v-else>
                                                <span>{{ startTime(item) }}</span>
                                                <span>&nbsp;-&nbsp;</span>
                                                <span>{{ endTime(item) }}</span>
                                            </span>
                                        </div>

                                        <div
                                            v-if="itemIsResizeable(item)"
                                            class="absolute top-0 bottom-0 left-0 flex items-center h-full pl-1 opacity-0 cursor-ew-resize group-hover:opacity-50"
                                            @mousedown="startOfResize($event, item, 'left')">

                                            <i class="fas fa-grip-lines-vertical"></i>

                                        </div>

                                        <div class="absolute flex items-center flex-1 h-full px-2 py-2 overflow-hidden text-sm"
                                             dusk="title"
                                             draggable="true"
                                             @dragstart="startDrag($event, item)"
                                             @dragend="onDrop"
                                        >
                                            <div class="truncate pointer-events-none">
                                                <span v-html="nl2br(item.title)"></span>
                                            </div>
                                        </div>

                                        <div
                                            v-if="itemIsResizeable(item)"
                                            class="absolute top-0 bottom-0 right-0 flex items-center h-full pr-1 opacity-0 cursor-ew-resize group-hover:opacity-50"
                                            @mousedown="startOfResize($event, item)">

                                            <i class="fas fa-grip-lines-vertical"></i>

                                        </div>
                                    </div>
                                </a>

                            </template>

                        </div>

                    </div>

                </div>
            </div>
        </div>

    </div>

</template>

<script>

function initialState() {
    return {
        current: null,
        row: null,
        columnStart: null,
        length: null,
        position: false,
        resize: false,
        start: {
            direction: null,
            x: null,
            y: null,
            width: 0,
            height: 0,
        },
    }
}

export default {

    props: {
        licensePlates: Array,
        pulledMaterialWarningGroups: Object,
        columns: Number,
        date: String,
    },

    data() {
        return {
            items: [],

            propLicensePlates: this.licensePlates,
            dragging: initialState(),
            toggledWarnings: {
                'examination-warning': false,
                'examination-alert': false,
                'permits-warning': false,
                'permits-alert': false,
            },
        }
    },

    created() {
        this.getAllItems();
    },

    methods: {

        // TODO Critical: Polling
        getAllItems() {
            let url = window.location.href.split('?')[0];

            let ajaxItems = axios.get(url + '/getItems', {
                params: {
                    'date': this.date
                }
            });

            ajaxItems.then((response) => {
                this.items = response.data;
            });
        },

        gridColumnTailwindCompile() {
            return [
                'grid-cols-[repeat(56,_1fr)]',
                'bg-green-100', 'border-green-200', 'text-green-800',
                'bg-indigo-100', 'border-indigo-200', 'text-indigo-800',
                'bg-purple-100', 'border-purple-200', 'text-purple-800',
                'bg-yellow-100', 'border-yellow-200', 'text-yellow-800',
                'bg-blue-100', 'border-blue-200', 'text-blue-800',
                'bg-red-100', 'border-red-200', 'text-red-800',
                'bg-orange-100', 'border-orange-200', 'text-orange-800',
                'bg-pink-100', 'border-pink-200', 'text-pink-800',
            ]
        },

        gridColumnClass() {
            return 'grid-cols-[repeat(' + this.columns + ',_1fr)]';
        },

        numbersBetween(start, stop, step) {
            return Array.from({length: (stop - start) / step + 1}, (_, i) => start + (i * step));
        },

        getItemsByRow(row) {
            return this.items.filter((item) => item.row === row);
        },

        getMaxSubRow(row) {
            return Math.max(...this.getItemsByRow(row).map(item => item.sub_row)) + 1;
        },

        getGridRow(item, itemsByRow) {
            let overlappedItems = this.checkForOverlappedItems(item, itemsByRow);

            if (!overlappedItems) {
                return 1;
            }

            // Sort items with current item based on start column
            overlappedItems = JSON.parse(JSON.stringify(overlappedItems));
            overlappedItems.push(item);

            let overlappedItemsSorted = overlappedItems.sort((a, b) => {
                let differenceSort = a.columnStart - b.columnStart;

                return differenceSort === 0 ? ('' + a.id).localeCompare(b.id) : differenceSort;
            });

            // Apply sub row based on sorting
            overlappedItemsSorted = overlappedItemsSorted.map((overlappedItem, index) => {
                overlappedItem.sub_row = index + 1;

                return overlappedItem;
            });

            return overlappedItemsSorted.find((overlappedItem) => item.id === overlappedItem.id).sub_row;
        },

        checkForOverlappedItems(item, itemsByRow) {
            return itemsByRow.filter((itemByRow) => {
                // Is the same item?
                if (item.id === itemByRow.id) {
                    return false;
                }

                let numbersInItem = this.numbersBetween(item.columnStart, item.columnStart + item.length - 1, 1),
                    numbersInItemByRow = this.numbersBetween(itemByRow.columnStart, itemByRow.columnStart + itemByRow.length - 1, 1);

                return !!numbersInItem.find((number) => numbersInItemByRow.includes(number));
            });
        },

        startTime(item) {
            // Get item start time
            let date = this.getItemStartTime(item);

            // Format
            return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
        },

        getItemStartTime(item) {
            // Get first available start time
            let calendarStartTimeInMins = 60 * 6 - 15, // 60 * 6 = 6 hours. - 15 because of item.columnStart = 1 then we add 15 minutes to the time
                startTimeInMins = calendarStartTimeInMins + 15 * item.columnStart;

            // Get start of current date
            let dateParts = this.date.split('-'),
                date = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);

            // Set start time on date
            date.setMinutes(startTimeInMins);

            return date;
        },

        endTime(item) {
            let date = this.getItemStartTime(item);

            // Calculate end date
            date.setMinutes(date.getMinutes() + 15 * item.length);

            // Format
            return ('0' + date.getHours()).slice(-2) + ':' + ('0' + date.getMinutes()).slice(-2);
        },

        startOfResize(event, item, leftOrRight = 'right') {
            // If is not left mouse click?
            if (event.which !== 1) {
                return;
            }

            // Set start of dragging, so we can check the difference between begin and end drag
            this.dragging.resize = true;
            this.setDraggingValues(event, item, leftOrRight);

            // Copy current values from object to dragging
            this.$set(item.box, 'columnStart', item.columnStart);
            this.$set(item.box, 'length', item.length);
        },

        /**
         * Set all values we need so we can check where and how the user drags
         *
         * @param event
         * @param item
         * @param leftOrRight
         */
        setDraggingValues(event, item, leftOrRight = 'right') {
            this.$set(this.dragging.start, 'x', event.clientX);
            this.$set(this.dragging.start, 'direction', leftOrRight);
            // this.$set(this.dragging.start, 'y', event.clientY);
            this.$set(this.dragging.start, 'width', event.target.offsetWidth);
            // this.$set(this.dragging.offsetHeight, 'height', event.target.offsetHeight);
            this.$set(this.dragging, 'current', item.id);
        },

        isResizing: function (event, item) {
            if (!this.dragging.start.x || this.dragging.position) {
                return;
            }

            let columnChanges = this.calculateColumnDragged(event);

            if (this.dragging.start.direction === 'left') {
                // 1. Start column based on the dragged amount of items. If this is too much left, then default to 1
                // 2. Current last column for calculations
                // 3. Column length based on the last column and the new start column
                let columnStart = columnChanges.newColumnDragged > 1 ? columnChanges.newColumnDragged : 1,
                    currentLastColumn = columnChanges.item.columnStart + columnChanges.item.length,
                    columnLength = currentLastColumn - columnStart;

                // If new start column is past the last current column
                if (columnStart >= currentLastColumn) {
                    columnStart = currentLastColumn - 1;
                    columnLength = 1;
                }

                // Set new column start based on dragging left or right from left drag icon
                this.$set(columnChanges.item.box, 'columnStart', columnStart);
                this.$set(columnChanges.item.box, 'length', columnLength);
            } else {
                // Set new length when dragging to the right
                this.$set(columnChanges.item.box, 'columnStart', columnChanges.item.columnStart);
                this.$set(columnChanges.item.box, 'length', columnChanges.difference);
            }
        },

        calculateColumnDragged(event) {
            // Calculate how many rows the new width has to be
            let columnWidth = this.$refs.column[0].offsetWidth / this.columns,
                amountDragged = event.clientX - this.dragging.start.x,
                columnsDragged = Math.round(amountDragged / columnWidth);

            // Get current item being dragged. Then change the length of the block
            let currentDragItem = this.findCurrentDragItem(),
                columnDifference = currentDragItem.length + columnsDragged,
                newColumnDragged = currentDragItem.columnStart + columnsDragged;

            return {
                'item': currentDragItem,
                'columnsDragged': columnsDragged,
                'newColumnDragged': newColumnDragged,
                'difference': columnDifference > 1 ? columnDifference : 1
            };
        },

        stopResize() {
            if (!this.dragging.resize) {
                return;
            }

            let currentDragItem = this.findCurrentDragItem();

            // Set length of current drag item to 'fake box' and reset the fake box to empty
            this.$set(currentDragItem, 'columnStart', currentDragItem.box.columnStart);
            this.$set(currentDragItem, 'length', currentDragItem.box.length);
            this.$set(currentDragItem, 'box', {});

            this.save(currentDragItem);

            // Reset all dragging params
            this.resetDraggingParameters();
        },

        startDrag(event, item) {
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'

            this.$set(this.dragging, 'position', true);
            this.$set(this.dragging, 'length', item.length);

            this.setDraggingValues(event, item);
        },

        onDragOver(event, row) {

            // Abort due to dragged nothing?
            if(!this.dragging.current)
                return;

            //
            let columnChanges = this.calculateColumnDragged(event),
                newStartColumn = columnChanges.newColumnDragged;

            // Item can be dragged to a different day?
            if (columnChanges.item.currentDayOnly) {
                // First check if calendar item can be longer than the end of the current day
                // Column dragged too far to the right?
                if (columnChanges.newColumnDragged + columnChanges.item.length > this.columns) {
                    newStartColumn = this.columns - columnChanges.item.length + 1;
                }
                // Column dragged too far left?
                else if (columnChanges.newColumnDragged <= 0) {
                    newStartColumn = 1
                }
            }

            let updatedRow = columnChanges.item.locked.row ? columnChanges.item.row : row,
                updatedColumn = columnChanges.item.locked.column ? columnChanges.item.columnStart : newStartColumn;

            // Set new row and column for fake item
            this.$set(this.dragging, 'row', updatedRow);
            this.$set(this.dragging, 'columnStart', updatedColumn);
        },

        // @DUSK @TESTING Quick drag and drop action for dusk tests
        updatePosition(calendarID, columnStart, length, row)
        {
            let item = this.items.find((item) => item.id === calendarID);

            // Change column if not locked
            if( !item.locked.column ) {
                item.columnStart = columnStart;
            }

            item.length = length;

            // Change row if not locked
            if( !item.locked.row ) {
                item.row = row;
            }

            this.save(item);
        },

        onDrop() {
            if (!this.dragging.position) {
                return;
            }

            const item = this.findCurrentDragItem();

            // Set new row and column for item; then reset fake box
            item.row = this.dragging.row;
            item.columnStart = this.dragging.columnStart;

            this.save(item);

            this.resetDraggingParameters();
        },

        save(item) {
            let url = window.location.href.split('?')[0];

            // Set item as loading
            item.loading = true;

            // Save item
            axios.post(url + '/saveItem', {
                item: item,
                date: this.date
            }).then(() => {
                item.loading = false;
            }).catch(() => {
                Vue.toasted.error('Er is iets misgegaan. Ververs de pagina.');
            });
        },

        resetDraggingParameters() {
            Object.assign(this.$data.dragging, initialState());
        },

        findCurrentDragItem() {
            return this.items.find(item => item.id === this.dragging.current);
        },

        nl2br: (value) => {
            return value.replace(/(\\r)*\\n/g, '<br>')
        },

        calendarItemLongerThenDay(item)
        {
            return item.columnStart < 0
                && (item.columnStart + item.length) > 0
                && item.length > this.columns;
        },

        itemIsResizeable(item) {
            let idPieces = item.id.split('-');

            if(idPieces[0] == 'relocation')
                return idPieces[2] != 'relocations';

            else if(idPieces[0] == 'order')
                return idPieces[2] != 'both';

            else
                return true;
        },

        toggleWarning(type) {
            this.toggledWarnings[type] = !this.toggledWarnings[type];
        },

        toggleLicensePlate(licensePlate) {
            // Close all other licensePlates except the one we clicked on
            this.propLicensePlates.filter(propLicensePlate => propLicensePlate.id != licensePlate.id).forEach((licensePlate) => {
                licensePlate.showPermits = false;
            });

            licensePlate.showPermits = !licensePlate.showPermits;
        }

    }


}

</script>
